import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                close: 'close',
                toggleSubNav: 'toggleSubNav',
                toggleSubNav2: 'toggleSubNav2',
            }
        }
    }

    init() {
        if (document.getElementsByClassName('-sub-active').length > 0){
            let el = document.getElementsByClassName('-sub-active')[0].getAttribute('data-id');

            for (let a = 0; a < document.getElementsByClassName('c-nav_secondary_component').length; a++) {
                if (document.getElementsByClassName('c-nav_secondary_component')[a].getAttribute('data-id') == el) {
                    document.getElementsByClassName('c-nav_secondary_component')[a].classList.add('is-deployed');
                }
            }
        }
    }

    close() {
        const html = document.querySelector('html');
        const burger = document.querySelector('.c-header_nav_burger');
        const text = burger.querySelector('.-hover');
        html.classList.remove('has-navOpen');
        burger.classList.remove('is-active');
        text.textContent = text.dataset.texthover;
    }

    toggleSubNav(e){
        let id = e.currentTarget.getAttribute('data-id');

        if(e.currentTarget.classList.contains('-sub-active')){
            e.currentTarget.classList.remove('-sub-active');
            if (document.getElementsByClassName('is-deployed').length > 0) document.getElementsByClassName('is-deployed')[0].classList.remove('is-deployed');
            if (document.getElementsByClassName('-is-mobileActive').length > 0) document.getElementsByClassName('-is-mobileActive')[0].classList.remove('-is-mobileActive');
        } else{
            if (document.getElementsByClassName('-sub-active').length > 0){
                document.getElementsByClassName('-sub-active')[0].classList.remove('-sub-active');
                if (document.getElementsByClassName('is-deployed').length > 0) document.getElementsByClassName('is-deployed')[0].classList.remove('is-deployed');
                if (document.getElementsByClassName('-is-mobileActive').length > 0) document.getElementsByClassName('-is-mobileActive')[0].classList.remove('-is-mobileActive');
            }
            e.currentTarget.classList.add('-sub-active');
            e.currentTarget.childNodes[3].classList.add('-is-mobileActive');
            for(let i = 0; i < document.getElementsByClassName('c-nav_secondary_component').length; i++) {
                if(document.getElementsByClassName('c-nav_secondary_component')[i].getAttribute('data-id') == id){
                    document.getElementsByClassName('c-nav_secondary_component')[i].classList.add('is-deployed');
                }
            }
        }
        
    }

    toggleSubNav2(e){
        if (document.getElementsByClassName('-is-deployed2').lenght > 0) document.getElementsByClassName('-is-deployed2')[0].classList.remove('-is-deployed2');
        if (document.getElementsByClassName('-is-mobileActive2').lenght > 0){
            document.getElementsByClassName('-is-mobileActive2')[0].classList.remove('-is-mobileActive2');
            e.currentTarget.classList.remove('-sub-active2');
        } 
        if (e.currentTarget.classList.contains('-is-deployed2') || e.currentTarget.classList.contains('-is-mobileActive2')) {
            e.currentTarget.classList.remove('-is-deployed2');
            e.currentTarget.childNodes[3].classList.remove('-is-mobileActive2');
            e.currentTarget.classList.remove('-sub-active2');
        } else{
            e.currentTarget.classList.add('-is-deployed2');
            e.currentTarget.childNodes[3].classList.add('-is-mobileActive2');
            e.currentTarget.classList.add('-sub-active2');
        }
    }
}
